"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getStarRatingSlots = exports.default = exports.StarRating = void 0;
var _icons = require("@ori-ui/icons");
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _starRatingClasses = _interopRequireWildcard(require("./starRatingClasses"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _$t in e)"default" !== _$t && ({}).hasOwnProperty.call(e, _$t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _$t)) && (i.get || i.set) ? o(f, _$t, i) : f[_$t] = e[_$t]);
        return f;
    })(e, t);
}
/**
 * Helper function to round value to one decimal place if necessary.
 * Normal round function rounds to decimal value even if its not necessary.
 * @param num value to be rounded
 * @returns Special rounded value only if needed. 10.4444 => 10.4; 10 => 10
 */ var roundUtil = function(num) {
    var decimalPlaces = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var baseNumber = Number("".concat(num, "e+").concat(decimalPlaces));
    return +"".concat(Math.round(baseNumber), "e-").concat(decimalPlaces);
};
var getStarRatingSlots = function(_) {
    return {
        root: [
            'root'
        ],
        star: [
            'star'
        ],
        textRating: [
            'textRating'
        ],
        emptyStar: [
            'emptyStar'
        ],
        fullStar: [
            'fullStar'
        ],
        halfStar: [
            'halfStar'
        ]
    };
};
exports.getStarRatingSlots = getStarRatingSlots;
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = getStarRatingSlots(ownerState);
    return (0, _base.unstable_composeClasses)(slots, _starRatingClasses.getStarRatingUtilityClass, classes);
};
var StarRatingRoot = (0, _material.styled)('span', {
    name: 'MuiOriStarRating',
    slot: 'Root',
    overridesResolver: function(_, styles) {
        return [
            styles.root,
            _define_property({}, ".".concat(_starRatingClasses.default.textRating), styles.textRating)
        ];
    }
})(function(param) {
    var theme = param.theme;
    return _define_property({
        display: 'flex',
        alignItems: 'center',
        gap: '5px'
    }, ".".concat(_starRatingClasses.default.textRating), {
        fontSize: '75%',
        marginLeft: '5px',
        fontWeight: theme.typography.fontWeightMedium,
        color: theme.palette.grey['700']
    });
});
var StarHalfWrap = (0, _material.styled)('div', {
    name: 'MuiOriStarRating',
    slot: 'HalfStarWrap'
})({
    position: 'relative',
    display: 'flex'
});
var StyledStarIcon = (0, _material.styled)(_icons.FavouriteFilled, {
    name: 'MuiOriStarRating',
    slot: 'Star',
    shouldForwardProp: function(prop) {
        return prop !== 'starPercentageWidth';
    },
    overridesResolver: function(param, styles) {
        var starType = param.ownerState.starType;
        return [
            styles.star,
            styles["".concat(starType, "Star")]
        ];
    }
})(function(param) {
    var theme = param.theme, _param_ownerState = param.ownerState, starType = _param_ownerState.starType, starPercentageWidth = _param_ownerState.starPercentageWidth;
    return _object_spread({
        fontSize: '1.46em',
        // To get rid of mui icon spaces in icons
        margin: '0 -4px'
    }, starType === 'empty' && {
        color: theme.palette.grey['200']
    }, starType === 'half' && {
        position: 'absolute',
        left: 0,
        top: 0,
        // Star is rendered as a whole, we only show part of it. For this we use clip-path css property and rotate after clipping.
        // Clipping value is not exactly percentage value - its "100% - somePercentageValue%"
        clipPath: "inset(0 0 0 ".concat(100 - (starPercentageWidth !== null && starPercentageWidth !== void 0 ? starPercentageWidth : 50), "%)"),
        transform: 'rotateY(180deg)',
        zIndex: 1
    }, (starType === 'half' || starType === 'full') && {
        color: theme.palette.default.dark
    });
});
var StarRatingItem = /*#__PURE__*/ (0, _react.memo)(function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledStarIcon, {
        ownerState: props,
        "data-star-type": props.starType,
        className: props.className
    });
});
var StarRatingText = /*#__PURE__*/ (0, _react.memo)(function(param) {
    var formattedValue = param.formattedValue, showTextRating = param.showTextRating, showVotes = param.showVotes, votes = param.votes;
    if (showVotes) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            className: _starRatingClasses.default.textRating,
            children: [
                "(",
                votes,
                ")"
            ]
        });
    } else if (showTextRating) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            className: _starRatingClasses.default.textRating,
            children: [
                "(",
                formattedValue,
                ")"
            ]
        });
    }
    return null;
});
var StarRating = exports.StarRating = /*#__PURE__*/ (0, _react.forwardRef)(function(inProps, ref) {
    var props = (0, _material.useThemeProps)({
        props: inProps,
        name: 'MuiOriStarRating'
    });
    var max = props.max, value = props.value, _props_showTextRating = props.showTextRating, showTextRating = _props_showTextRating === void 0 ? false : _props_showTextRating, _props_showVotes = props.showVotes, showVotes = _props_showVotes === void 0 ? false : _props_showVotes, votes = props.votes, _props_precise = props.precise, precise = _props_precise === void 0 ? false : _props_precise, _props_component = props.component, component = _props_component === void 0 ? 'div' : _props_component, className = props.className, rest = _object_without_properties(props, [
        "max",
        "value",
        "showTextRating",
        "showVotes",
        "votes",
        "precise",
        "component",
        "className"
    ]);
    var stars = (0, _react.useMemo)(function() {
        return Array.from({
            length: max
        }).map(function(_, index) {
            return index;
        }).map(function(index) {
            var result = value - index;
            var halfStarSize = 0;
            var halfStarCeiling = precise ? 0.9 : 0.5;
            var starType = 'empty';
            if (!precise) {
                // we round to closest 0.5, because we only want 0.5 or full numbers
                result = Math.round(result / 0.5) * 0.5;
            }
            if (result > 0) {
                if (result <= halfStarCeiling) {
                    starType = 'half';
                } else {
                    starType = 'full';
                }
            }
            if (starType === 'half') {
                halfStarSize = 100 * result / 1;
            }
            return {
                starId: index,
                starType: starType,
                halfStarSize: halfStarSize
            };
        });
    }, [
        max,
        value,
        precise
    ]);
    var classes = useUtilityClasses(props);
    var formattedValue = (0, _react.useMemo)(function() {
        return roundUtil(value);
    }, [
        value
    ]);
    var constructStarClassName = (0, _react.useCallback)(function(starType) {
        return (0, _clsx.default)(classes["".concat(starType, "Star")], classes.star);
    }, [
        classes
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StarRatingRoot, _object_spread_props(_object_spread({
        ref: ref,
        as: component,
        title: "".concat(formattedValue, "/").concat(max, " ★"),
        className: (0, _clsx.default)(classes.root, className),
        ownerState: props
    }, rest), {
        children: [
            stars.map(function(param) {
                var starType = param.starType, halfStarSize = param.halfStarSize, starId = param.starId;
                var starClassName = constructStarClassName(starType);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                    children: [
                        (starType === 'full' || starType === 'empty') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StarRatingItem, {
                            className: starClassName,
                            starType: starType
                        }),
                        starType === 'half' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StarHalfWrap, {
                            ownerState: props,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StarRatingItem, {
                                    className: starClassName,
                                    starPercentageWidth: halfStarSize,
                                    starType: starType
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StarRatingItem, {
                                    className: constructStarClassName('empty'),
                                    starType: "empty"
                                })
                            ]
                        })
                    ]
                }, starId);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StarRatingText, {
                showVotes: showVotes,
                votes: votes,
                showTextRating: showTextRating,
                formattedValue: formattedValue
            })
        ]
    }));
});
var _default = exports.default = StarRating; //# sourceMappingURL=StarRating.js.map
